<span class="icon" (click)="share()">
    <app-icon *ngIf="!simpleIcon" [type]="'Pinterest'"></app-icon>
    <app-icon *ngIf="simpleIcon" [type]="'pinterest-simple'"></app-icon>
</span>
